// extracted by mini-css-extract-plugin
export var quantityInput = "_f2-0";